<template>
    <div>

        <div v-if="loading" class="text-center">
            <i class="fa fa-circle-o-notch fa-spin"></i> Loading
        </div>
        <div v-else>
            <vue-headful :title="'Edit Incident Type :: MeritEHS'"/>

            <h4 class="py-3 mb-4">
                <ol class="breadcrumb font-weight-bold m-0">
                    <li class="breadcrumb-item font-weight-light">
                        <router-link :to="`/incidents`">
                            <i class="fa fa-stethoscope"></i> Incidents
                        </router-link>
                    </li>
                    <li class="breadcrumb-item font-weight-light">
                        <router-link :to="`/incidents/settings#incident_types`">Settings - Incident Types</router-link>
                    </li>
                    <li class="breadcrumb-item active">
                        <template v-if="incident_type_id"><i class="fa fa-edit"></i> Edit Incident Type</template>
                        <template v-else><i class="fa fa-plus"></i> Create Incident Type</template>
                    </li>
                </ol>
            </h4>

            <div class="row mb-4">
                <div class="col-md-8">
                    <div class="card">
                        <div class="card-body">
                            <div v-bind:class="{ 'form-group': true, 'has-error': errors.TypeName }" class="row">
                                <label class="col-md-3 col-sm-4 col-form-label text-sm-right">Incident Type Name:</label>
                                <div class="col-md-6 col-sm-8">
                                    <input type="text" name="TypeName" v-model="incident_type.TypeName" class="form-control" placeholder="Enter Incident Type Name" />
                                    <span v-if="errors.TypeName" class="text-danger">
                                        <span v-for="error in errors.TypeName">{{ error }}</span>
                                    </span>
                                </div>
                            </div>
                            <div v-bind:class="{ 'form-group': true}" class="row">
                                <label class="col-md-3 col-sm-4 col-form-label text-sm-right">Is Active:</label>
                                <div class="col-md-6 col-sm-8">
                                    <b-form-checkbox v-model="incident_type.IsActive" :value="1" :unchecked-value="0" plain />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <button type="button" class="btn btn-success" v-on:click="saveIncidentType(this)" :disabled="saving">
                Save Incident Type
            </button>
        </div>
    </div>
</template>

<script>
    export default {
        data: function() {
            return {
                loading: true,
                saving: false,
                incident_type_id: this.$route.params.id,
                incident_type: {},
                errors: {},
            }
        },

        methods: {
            getErrorClass: function(attribute) {
                return {
                    'form-group has-error': this.errors[attribute],
                    'form-group': !this.errors[attribute],
                }
            },
            getIncidentType: function() {
                //Get the data
                this.$http
                    .get('admin/incident-types-edit' + (this.incident_type_id ? '/' + this.incident_type_id : ''))
                    .then(response => {
                        //Set all the data
                        this.incident_type = response.data.incidentType;

                        //Set loading
                        this.loading = false;
                    })
                    .catch(response => {

                    });
            },

            saveIncidentType: function() {
                //Show loading
                this.saving = true;

                //Reset the errors
                this.errors = {};

                //Send it
                this.$http
                .post('admin/incident-types-edit' + (this.incident_type_id ? '/' + this.incident_type_id : ''), this.incident_type)
                .then(response => {
                    //Alert the user?
                    this.$toastr.success('Incident Type Saved');

                    //Return to main list?
                    this.$router.push('/incidents/settings/incident-types/builder/'+response.data.IncidentTypeId);
                })
                .catch(error => {
                    //Check for error
                    if(error.response && error.response.status === 422)
                    {
                        //Display validation errors
                        this.errors = error.response.data
                    }
                    else
                    {
                        this.$toastr.error(error);
                    }
                })
                .then(response => {
                    //Show loading
                    this.saving = false;
                });
            }
        },

        mounted() {
            //Get the incidents
            this.getIncidentType();
        }
    }
</script>
